import React from 'react';
import {
  validateRequired,
  validateString,
  validationObject,
} from 'utils/validations';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import { eventTypeActions, eventTypeSelectors } from '../';
import BaseForm from 'containers/Base/BaseForm.js';
import { getEventCategoryByServices } from 'containers/Pages/Events/Layouts';
import { EventInfo } from 'utils/constants/informationText';
import {
  getSecurityCompanyId,
  getSecurityCompanyServices,
} from 'reducers/securityCompany';

const initialState = {
  category: undefined,
  typeName: undefined,
  archived: false,
  id: undefined,
};
export const validationSchema = validationObject({
  category: validateRequired(),
  typeName: validateString(50, true),
});
const initialValues = data => {
  return data;
};

const EventTypeForm = ({
  editMode,
  closeForm,
  createEventType,
  updateEventType,
  persistentStateName,
}) => {
  const services = useSelector(state => getSecurityCompanyServices(state));
  const companyId = useSelector(state => getSecurityCompanyId(state));
  const details = useSelector(state =>
    eventTypeSelectors.getEventTypeRaw(state),
  );
  const onEdit = values => {
    updateEventType({
      eventType: { ...values },
    });
  };
  const onCreate = values => {
    values.companyID = companyId;
    createEventType({
      eventType: { ...values },
    });
  };
  const generalSection = services => {
    return [
      {
        field: 'category',
        label: 'Category',
        type: 'select',
        required: true,
        options: getEventCategoryByServices(services),
        info: EventInfo.category,
      },
      {
        field: 'typeName',
        label: 'Name',
        type: 'text',
        required: true,
      },
    ];
  };
  return (
    <BaseForm
      imageRequired={false}
      allowToArchive={true}
      generalSection={generalSection(services)}
      edit={editMode}
      onSubmit={editMode ? onEdit : onCreate}
      formTitle={editMode ? 'Edit Event Type' : 'Create Event Type'}
      closeForm={closeForm}
      initialValues={editMode ? initialValues(details) : initialState}
      persistentStateName={persistentStateName}
      validationSchema={validationSchema}
    />
  );
};
EventTypeForm.propTypes = {
  editMode: PropTypes.bool,
  closeForm: PropTypes.func,
  id: PropTypes.string,
  persistentStateName: PropTypes.string,
  createEventType: PropTypes.func,
  updateEventType: PropTypes.func,
  details: PropTypes.object,
};
const mapDispatchToProps = dispatch => ({
  createEventType: ({ eventType }) =>
    dispatch(eventTypeActions.createRowEntry({ eventType })),
  updateEventType: ({ eventType }) =>
    dispatch(eventTypeActions.updateRowEntry({ eventType })),
});
export default connect(null, mapDispatchToProps)(EventTypeForm);
